<template lang="html">

    <section class="registro">

        <encabezado :data="'generarNuevoConvenio'"></encabezado>


        <form class="form row-start ais container">
            <div class="contenedor-boton -relleno-data row-start">
                <a @click="requestUltimoConvenio" class="btn -solid-primary">Rellenar datos</a>
                <popup-info :texto="'ultimoconvenio'" :side="'right'"></popup-info>
            </div>
            <p>
                <strong>
                    Por favor, cumplimente los siguientes datos para generar el Convenio de Cooperación Educativa entre
                    su empresa y UPM.
                </strong>
            </p>

            <div class="contenedor-input mb-0 " v-if="contactosFirmanteConvenio.length != 0">
                <label for="" class="mt-20" id="selectContactFirmanteAnexo">Firmante del convenio</label>
                <p class="mb-0" @click="toggleNewContact">Si el/la firmante del convenio no está entre las
                    opciones disponibles, puede dar de alta uno/a nuevo/a <u class="cursor-pointer">dar de alta uno/a
                        nuevo/a</u></p>
                <select name="selectContactFirmanteConvenio" :key="contactoFirmanteConvenio"
                    v-model="contactoFirmanteConvenio" @change="changeContactoFirmanteConvenio" v-validate="'required'">
                    <option value=null disabled selected>- Selecciona un contacto</option>
                    <option :value="contact" v-for="contact in contactosFirmanteConvenio">
                        {{ contact.nombre }} {{ contact.apellidos }} </option>
                </select>
                <span class='error'>{{ errors.first('formOferta.selectContactFirmanteConvenio') }}</span>
            </div>
            <div v-if="newContact || contactoFirmanteConvenio" class="box-gray-content">
                <form @submit.prevent="handleSubmit" id="formContactFirmanteConvenio"
                    data-vv-scope="formContactFirmanteConvenio" v-if="!selectedContact">
                    <div class="contenedor-input full-input row-start">
                        <label>{{ $t('registro.tipo_contacto') }}*</label>
                        <template v-if="!!dominiosOrder && !!dominiosOrder.tiposContacoEmpresa">
                            <div class="radio-container" v-for="(tipo, key) in dominiosOrder.tiposContacoEmpresa">
                                <input type="checkbox" :value="tipo[0]" :id="'tipo-contacto-' + tipo[0]"
                                    v-model="data.tipoContacto" name="tipocontactoUsuario" :disabled="tipo[0] === '2'">
                                <label :for="'tipo-contacto-' + tipo[0]">{{ tipo[1] }}</label>
                            </div>
                        </template>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="nombre">Nombre*</label>
                        <input type="text" name="nombre" v-model="data.nombre" v-validate="'required|min:3'">
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.nombre') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="">Apellidos*</label>
                        <input type="text" name="apellidos" v-model="data.apellidos" v-validate="'required|min:3'">
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.apellidos') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot">
                        <label for="dni">DNI/NIE/Pasaporte*</label>
                        <input type="text" name="dni" v-model="data.nif" v-validate="{
                            required: true
                        }">
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.dni') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="">Cargo*</label>
                        <input type="text" name="cargo" v-model="data.puesto" v-validate="'required|min:3'">
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.cargo') }}</span>
                    </div>
                    <div class="contenedor-input one-slot -wo-margin">
                        <label for="email">{{ $t('registro.email') }}*</label>
                        <input type="text" name="email" v-model="data.email" v-validate="'required|email'">
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.email') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="telefono">Teléfono*</label>
                        <input type="text" name="telefono" v-model="data.telefono1"
                            v-validate="'required|max:14|min:9|integer'">
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.telefono') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="">Departamento</label>
                        <input type="text" name="departamento" v-model="data.departamento">
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.departamento') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="">Titulación</label>
                        <input type="text" name="titulacion" v-model="data.titulacion">
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.titulacion') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="">Dirección*</label>
                        <input type="text" name="direccion" v-model="data.direccion" v-validate="'required|min:3'">
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.direccion') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="">{{ $t('registro.cp') }}*</label>
                        <input type="text" name="cp" v-model="data.cp" v-validate="'required|numeric|min:5'"
                            autocomplete="nope">
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.cp') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot">
                        <label for="">{{ $t('oferta.pais') }}*</label>
                        <select name="pais" v-model="data.idPais" v-if="!!paises" v-validate="'required'">
                            <option value="">-Seleccionar-</option>
                            <option v-if="!!dominios" v-for="(el, key) in paises" :value="Number(el[0])">{{ el[1] }}
                            </option>
                        </select>
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.pais') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot">
                        <label for="">{{ $t('oferta.provincia') }}*</label>
                        <input type="text" name="provincia" v-model="data.provincia" v-if="data.idPais != 1"
                            v-validate="'required|min:3'">
                        <select name="provincia" v-model="data.provincia" v-else v-validate="'required'">
                            <option value="">-Selecciona una provincia-</option>
                            <option v-if="!!dominios" v-for="(el, key) in provincias" :value="Number(el[0])">{{ el[1] }}
                            </option>
                        </select>
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.provincia') }}</span>
                    </div>
                    <div class="contenedor-input one-slot">
                        <label for="">Localidad*</label>
                        <select name="localidad" v-model="data.idLocalidad"
                            v-if="data.idPais == '1' && brand.localidadesEnDominios" v-validate="'required'">
                            <option value="">{{ $t('registro.selecciona_localidad') }}</option>
                            <option v-if="!!dominios" v-for="(el, key) in localidadesfilter(data.provincia)"
                                :value="el.idLocalidad">
                                {{ el.descripcion }}
                            </option>
                        </select>
                        <input type="text" name="localidad" v-model="data.localidad" v-else
                            v-validate="'required|min:3'">
                        <span class='error'>{{ errors.first('formContactFirmanteConvenio.localidad') }}</span>
                    </div>
                    <div class="contenedor-input  row-start">
                        <span class="btn -solid-primary mb-0" @click="saveContacto">{{ $t('guardar') }}</span>
                    </div>
                </form>
                <template v-else>
                    <div class="container" style="margin-top:-10px;">
                        <div class="contenedor-datos row-start">
                            <h3 class="dato-cv w-100"
                                v-if="dominiosOrder.tiposContacoEmpresa && contactoFirmanteConvenio.tipoContacto && contactoFirmanteConvenio.tipoContacto.length > 0">
                                <strong>Tipo de contacto: </strong>
                                <template v-for="(n, key) in contactoFirmanteConvenio.tipoContacto">
                                    {{Object.values(dominiosOrder.tiposContacoEmpresa).find(elemento => elemento[0]
                                        == n)[1]}}
                                    {{ (key != contactoFirmanteConvenio.tipoContacto.length - 2) ?
                                        (key == contactoFirmanteConvenio.tipoContacto.length - 1) ? '' : ', ' : ' y '
                                    }}</template>
                            </h3>
                            <h3 class="dato-cv" v-if="contactoFirmanteConvenio.nombre">
                                <strong>Nombre: </strong>
                                {{ contactoFirmanteConvenio.nombre }}
                            </h3>
                            <h3 class="dato-cv" v-if="contactoFirmanteConvenio.nif">
                                <strong>DNI/NIE/Pasaporte: </strong>
                                {{ contactoFirmanteConvenio.nif }}
                            </h3>
                            <h3 class="dato-cv" v-if="contactoFirmanteConvenio.puesto">
                                <strong>Cargo: </strong>
                                {{ contactoFirmanteConvenio.puesto }}
                            </h3>
                            <h3 class="dato-cv" v-if="contactoFirmanteConvenio.email">
                                <strong>{{ $t('registro.email') }}: </strong>
                                {{ contactoFirmanteConvenio.email }}
                            </h3>
                            <h3 class="dato-cv" v-if="contactoFirmanteConvenio.telefono">
                                <strong>Teléfono: </strong>
                                {{ contactoFirmanteConvenio.telefono }}
                            </h3>
                            <h3 class="dato-cv" v-if="contactoFirmanteConvenio.titulacion">
                                <strong>Titulación: </strong>
                                {{ contactoFirmanteConvenio.titulacion }}
                            </h3>
                            <h3 class="dato-cv" v-if="contactoFirmanteConvenio.direccion">
                                <strong>Dirección: </strong>
                                {{ contactoFirmanteConvenio.direccion }}
                            </h3>
                            <h3 class="dato-cv" v-if="contactoFirmanteConvenio.cp">
                                <strong>{{ $t('registro.cp') }}: </strong>
                                {{ contactoFirmanteConvenio.cp }}
                            </h3>
                            <h3 class="dato-cv" v-if="contactoFirmanteConvenio.idPais && !!paises">
                                <strong>{{ $t('oferta.pais') }}: </strong>
                                {{paises.find(elemento => elemento[0] == contactoFirmanteConvenio.idPais)[1]}}
                            </h3>
                            <h3 class="dato-cv" v-if="contactoFirmanteConvenio.idPais == 1">
                                <strong>{{ $t('oferta.provincia') }}: </strong>
                                {{provincias.find(elemento => elemento[0] == contactoFirmanteConvenio.provincia)[1]}}
                            </h3>
                            <h3 class="dato-cv" v-if="contactoFirmanteConvenio.localidad">
                                <strong>Localidad: </strong>
                                {{ contactoFirmanteConvenio.localidad }}
                            </h3>
                        </div>
                    </div>
                </template>
            </div>
            <div class="contenedor-input fecha type-text middle-slot -wo-margin">
                <label for="fechaEscritura_firmante">Fecha escritura*</label>
                <!--                 <datepicker v-model="data.fechaEscritura" placeholder="Seleccionar fecha" :language="es"
                    :full-month-name="true" :monday-first="true" :format="'dd MMMM yyyy'" :minimum-view="'full'"
                    name="fechaEscritura_firmante" v-validate="'required'" :disabledDates="disabledDates"></datepicker> -->
                <datepicker v-model="data.fechaEscritura" placeholder="Seleccionar fecha" :language="es"
                    :full-month-name="true" :monday-first="true" :format="'dd MMMM yyyy'" :minimum-view="'full'"
                    name="fechaEscritura_firmante" v-validate="'required'"></datepicker>
                <span class='error' v-if="clicked">{{ errors.first('fechaEscritura_firmante') }}</span>
            </div>
            <div class="contenedor-input type-text middle-slot">
                <label for="notario_firmante">Notario*</label>
                <input type="text" name="notario_firmante" v-model="data.notario" v-validate="'required|min:3'">
                <span class='error' v-if="clicked">{{ errors.first('notario_firmante') }}</span>
            </div>
            <div class="contenedor-input type-text middle-slot">
                <label for="localidad_notario_firmante">Localidad del notario*</label>
                <input type="text" name="localidad_notario_firmante" v-model="data.localidadNotario"
                    v-validate="'required|min:3'">
                <span class='error' v-if="clicked">{{ errors.first('localidad_notario_firmante') }}</span>
            </div>
            <div class="contenedor-input three-slot">
                <input type="checkbox" name="politica" id="politica" v-validate="'required'">
                <label for="politica">Declaro expresamente que son ciertos los datos aportados por la entidad en su
                    solicitud de Convenio de colaboración educativa; que la entidad se encuentra al corriente en el
                    cumplimiento de las obligaciones tributarias y con la Seguridad Social impuestas por las
                    disposiciones vigentes; y que la entidad no está, ni ha estado incursa, en procedimientos de
                    regulación de empleo en los tres meses anteriores a la solicitud del Convenio. La entidad se
                    compromete, si fuese necesario, a aportar la justificación acreditativa de tales requisitos en el
                    plazo máximo de diez días hábiles siguientes a aquél en que reciba el correspondiente
                    requerimiento.</label>
                <span class='error' v-if="clicked">{{ errors.first('politica') }}</span>
            </div>


            <div class="contenedor-boton">
                <a @click="validate" :loading="loadingbtn" class="btn -solid-primary">Solicitar convenio</a>
            </div>



        </form>

        <!-- <loading v-else></loading> -->




    </section>

</template>

<script lang="js">

import encabezado from '@/components/parts/encabezado';

import arrowLink from '@/components/parts/icons/arrow-link'

import { mapGetters, mapActions } from 'vuex';

import toggle from '@/components/parts/form/toggle'

import addIcon from '@/components/parts/icons/add'

import Datepicker from 'vuejs-datepicker';

import { ca, es } from 'vuejs-datepicker/dist/locale';

import popupInfo from '@/components/parts/popup-info';

import loading from '@/components/parts/loading';

import axios from 'axios'


import addContacto from '@/components/views/documentacion/addContacto'
import addCuentaFacturacion from '@/components/views/documentacion/addCuentaFacturacion'


import router from '@/router';

import Vue from 'vue';
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import { Validator } from 'vee-validate';

import confirmPopUp from '@/components/parts/confirm-popup';


Validator.extend('checkdni', {
    validate: value => {
        var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
        var nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        var nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
        var str = value.toString().toUpperCase();

        if (!nifRexp.test(str) && !nieRexp.test(str)) return false;

        var nie = str
            .replace(/^[X]/, '0')
            .replace(/^[Y]/, '1')
            .replace(/^[Z]/, '2');

        var letter = str.substr(-1);
        var charIndex = parseInt(nie.substr(0, 8)) % 23;

        if (validChars.charAt(charIndex) === letter) return true;

        return false;
    },
    getMessage: field => 'El campo DNI está mal formado',
});


export default {
    name: 'solicitud-cambio-practica',
    mounted() {
        this.requestContactosFirmanteConvenio();
    },
    data() {
        return {
            clicked: false,
            loading: false,
            loadingbtn: false,
            es: es,
            ca: ca,
            contactoFirmanteConvenio: null,
            newContact: false,
            idNewContact: null,
            selectedContact: false,
            data: {
                "nombre": "",
                "apellidos": "",
                "nif": "",
                "puesto": "",
                "email": "",
                "fechaEscritura": "",
                "notario": "",
                "localidadNotario": "",
                "telefono1": "",
                "departamento": "",
                "titulacion": "",
                "direccion": "",
                "cp": "",
                "idPais": "",
                "provincia": "",
                "idLocalidad": "",
                "localidad": "",
                "tipoContacto": ['2'],
            },
            showpopup: false,
            /*                 disabledDates: {
                                ranges: [{ 
                                    from: new Date(1800),
                                    to: (d => new Date(d.setDate(d.getDate() - 1)))(new Date)
                                }]
                            }, */
        }
    },
    computed: {
        ...mapGetters({
            dominios: 'getDominios',
            dominiosOrder: 'getDominiosOrder',
            brand: 'getBrand',
            tiposContacto: 'getTipoContactoEmpresa',
            paises: 'getPaises',
            provincias: 'getProvincias',
            contactosFirmanteConvenio: 'getContactosFirmanteConvenio',
        }),
        convenioData() {
            return {
                "nombre": this.contactoFirmanteConvenio['nombre'],
                "apellidos": this.contactoFirmanteConvenio['apellidos'],
                "dni": this.contactoFirmanteConvenio['nif'],
                "cargo": this.contactoFirmanteConvenio['puesto'],
                "email": this.contactoFirmanteConvenio['email'],
                "fechaEscritura": this.data['fechaEscritura'],
                "notario": this.data['notario'],
                "localidadNotario": this.data['localidadNotario'],
                "idContactoFirmante": this.contactoFirmanteConvenio['idContacto']
            }
        }
    },
    methods: {
        ...mapActions(['addConvenioEmpresa', 'requestContactosFirmanteConvenio', 'addContactoEmpresa']),
        requestUltimoConvenio() {
            axios.get(`/api/Empresa/dameDetalleUltimoConvenioEmpresa`).then(r => {
                if (r.data.status == 0) {
                    this.data = r.data.datos;
                    if (this.data.fechaEscritura) {
                        this.data.fechaEscritura = this.parseFechaEscritura(this.data.fechaEscritura);
                    }
                }
            }).catch(error => {
                commit('setError', 500);
                dispatch('sendErrorServer', error.response);
            });
        },
        parseFechaEscritura(value) {
            if (value instanceof Date) {
                return value;
            }
            if (typeof value === 'string') {
                const isoLike = value.match(/^\d{4}-\d{2}-\d{2}/);
                if (isoLike) {
                    return new Date(value);
                }
                const slashParts = value.split('/');
                if (slashParts.length === 3) {
                    const [day, month, year] = slashParts.map(part => Number(part));
                    if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
                        return new Date(year, month - 1, day);
                    }
                }
            }
            return new Date(value);
        },
        addedContact() {
            this.newuser.show = false;
            this.requestContactos();
        },


        validate() {
            this.clicked = true;
            this.$validator.validateAll()
                .then(itsOk => {
                    if (itsOk) {
                        this.clicked = false;
                        this.sendData()


                    } else {
                        $('html,body').animate({ scrollTop: $("*[aria-invalid=true").offset().top - 150 }, 400);
                    }

                });
        },
        sendData() {
            this.loading = true;
            this.addConvenioEmpresa(this.convenioData).then(r => {
                this.loading = false;
                if (r) {
                    this.showpopup = false;
                }
            });
        },
        toggleNewContact() {
            if (this.newContact) {
                this.newContact = false;
            } else {
                this.newContact = true;
            }
            this.contactoFirmanteConvenio = null;
            this.selectedContact = false;
        },
        changeContactoFirmanteConvenio() {
            this.selectedContact = true;
            this.newContact = false;
        },
        saveContacto() {
            this.loading = true;
            this.$validator.validateAll('formContactFirmanteConvenio')
                .then(itsOk => {
                    if (!itsOk) {
                        this.loading = false;
                        return;
                    }
                    this.addContactoEmpresa(this.data)
                        .then(result => {
                            return this.requestContactosFirmanteConvenio().then(() => {
                                this.idNewContact = result.idNuevaAlta;
                            });
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                });
        }
    },
    components: {
        'encabezado': encabezado,
        'arrow-link': arrowLink,
        'toggle': toggle,
        'add-icon': addIcon,
        Datepicker,
        'popup-info': popupInfo,
        'loading': loading,
        'add-contacto': addContacto,
        'add-cuenta-facturacion': addCuentaFacturacion,
        'confirm-popup': confirmPopUp,
    },
    watch: {
        'idNewContact': function (value) {
            this.contactoFirmanteConvenio = this.contactosFirmanteConvenio.find(c => c.idContacto == value);
            this.changeContactoFirmanteConvenio()
        }
    }
}



</script>

<style scoped lang="scss">
form {
    padding-top: 50px;
}

#formContactFirmanteConvenio {
    padding-top: 0px;

    .contenedor-input.full-input {
        padding-bottom: 20px;
        margin-bottom: 20px;

        label {
            margin-bottom: 10px;
        }
    }
}

.epigrafe {
    margin-bottom: 20px;
}

.contenedor-boton {
    margin-top: 0px;
    padding-left: 30px;
    width: 100%;
    margin-bottom: 30px;

    &.-relleno-data {
        width: auto;
        display: inline-block;
        position: relative;
        padding-right: 30px;

        .popup-info {
            right: 0;
        }
    }
}

.form .with-toggle {
    width: 100%;
    margin-bottom: 30px;


    .contenedor-toogle {
        position: relative;
        right: auto;
        top: auto;
    }

    &.fecha {
        width: 33.33333333%;
        margin-bottom: 0;
        padding-bottom: 0;

        .contenedor-toogle {
            position: absolute;
            right: 0px;
            top: 0px;
        }
    }
}

.-forma-pago {
    margin-bottom: 5px;
}

.-iban label {
    width: 100%;
}

.-iban input {
    width: auto;
    letter-spacing: 1px;
}

.-iban span {
    margin: 0 5px;

    &:last-of-type {
        display: none;
    }
}

.contenedor-iban {
    flex-wrap: nowrap;
}

.-iban input[campos=n-2] {
    width: calc(12px * 2);
}

.-iban input[campos=n-4] {
    width: calc(12px * 4);
}

.-iban input[campos=n-10] {
    width: calc(12px * 10);
}

.legal-info {
    max-width: 800px;
    padding-left: 30px;
    margin-top: 20px;

    h2 {
        text-align: left;
        font-size: 15px;
        margin-bottom: 10px;
        font-weight: bold;
    }

    p {
        font-size: 13px;
        margin-bottom: 0px;
    }
}

.contenedor-input input[type="checkbox"]+label {
    line-height: 1.2em;

    &:before {
        top: 10px;
    }
}

.box-gray-content .dato-cv {
    width: 50%;
}

@media screen and (max-width: 900px) {
    .contenedor-boton {
        padding-left: 0px;
        margin-top: 30px;
    }

    .add-link {
        margin-left: 0;
    }


    .legal-info {
        padding-left: 0;
    }

    .form .with-toggle.fecha {
        width: 100%;
    }


}

@media screen and (max-width: 768px) {
    .box-gray-content .dato-cv {
        width: 100%;
    }
}

@media screen and (max-width: 340px) {
    .form .with-toggle.fecha strong {
        font-size: 14px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/views/documentacion/generar-nuevo-convenio.vue